import React from 'react'

export default function Footer() {
  return (
    <footer className="bg-[#360000] text-white py-10 w-full">
    <div className="container mx-auto text-center text-sm">
      &copy; 2024 Student-Teacher and Guidance Online Consultation System. All rights reserved.
    </div>
  </footer>
  )
}
